module.exports = __webpack_public_path__ + "img/newlogo.c37de3ed.png";